import React from 'react';
import moment from 'moment';

const CollectionDetails = ({ columnName, collectionDateTimeLocal, postcode }) => (
  <div>
    {columnName !== 'reschedule' && (
      <span>
        <b>{moment(collectionDateTimeLocal).format('DD MMM YYYY')}</b>
        {' - '}
      </span>
    )}
    {postcode}
  </div>
);

export default CollectionDetails;
